import useAuth from "Hooks/useAuth";
import React from "react";
import { Helmet } from "react-helmet";
import logo from "../../Assets/groupos-logo.svg";
const Meta = ({ title }) => {
  const { auth } = useAuth();
  return (
    <Helmet>
      <link
        rel="icon"
        href={
          auth?.currentEdge?.relation_id?.logo
            ? auth?.currentEdge?.relation_id?.logo
            : logo
        }
      />
      <title>
        {auth?.currentEdge?.relation_id?.nickname
          ? auth?.currentEdge?.relation_id?.nickname
          : "groupos"}{" "}
        - {title}
      </title>
    </Helmet>
  );
};

export default Meta;
